<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <select class="form-select" :class="errorMessage ? 'is-invalid' : ''" v-model="value">
      <option v-for="option in options" :key="option[valueKey]" :value="option[valueKey]">
        {{ option[textKey] }}
      </option>
    </select>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </form-layout>
</template>
<script>
import BaseVuexFormItem from "@/views/molecules/formItems/BaseVuexFormItem";
import FormLayout from "@/views/templates/FormLayout";

export default {
  name: "VuexSelectFormItem",
  extends: BaseVuexFormItem,
  components: {FormLayout},
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    textKey: {
      type: String,
      default: 'text'
    },
  },
}
</script>
